import React from 'react';

interface Props {
    titleCase?: boolean;
    via?: 'email' | 'chat';
}

export default function ContactSupportLink({ titleCase = false, via = 'chat' }: Props) {
    const handleClick = () => {
        via === 'email' ? window.open('mailto:support@pricewell.io') : window.$crisp.push(['do', 'chat:open']);
    };
    return (
        <button onClick={handleClick} className="underline">
            {titleCase ? 'G' : 'g'}et in touch with support
        </button>
    );
}
